module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('navtop'), _vm._v(" "), _c('ul', {
    staticClass: "resList"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.checkLogin(_vm.roomInfo.roomId)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.roomInfo.roomPic
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('p', [_vm._v(_vm._s(_vm.roomInfo.roomName))]), _vm._v(" "), _c('span', [_vm._v("房间ID:" + _vm._s(_vm.roomInfo.roomid || _vm.roomInfo.roomId))])]), _vm._v(" "), _c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f7f46d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dating/search.vue
// module id = 113
// module chunks = 0